import React, { useState } from 'react';
import axios from 'axios';

// 🔑 RE-READ THE STORED CREDIT REPORT (Jesse, 2026-10-21 — LOX Tier 1). Staff use this once a credit field mapping
// is fixed (the "Credit report records not read" alert): it re-reads the report already on file with the current
// mapping — POST /api/admin/borrowers/:id/credit-reanalyze-stored — with no new credit pull and no inquiry.
// Answered letters are kept; the counts come back to show what changed.
export { rereadTargetId } from '../../utils/reviewTabRules';

export default function RereadStoredReport({ borrowerId, headers, api, onDone }) {
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const run = async () => {
    setBusy(true); setError(null);
    try {
      const { data } = await axios.post(`${api}/api/admin/borrowers/${borrowerId}/credit-reanalyze-stored`, {}, { headers });
      setResult(data);
      setConfirming(false);
      if (onDone) await onDone();
    } catch (e) {
      setError(e?.response?.data?.error || 'The stored credit report could not be re-read.');
    } finally {
      setBusy(false);
    }
  };

  const btn = {
    fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 4, cursor: busy ? 'not-allowed' : 'pointer',
    border: '1px solid #c7d2fe', background: '#fff', color: '#3730a3',
  };
  if (!borrowerId) return null;
  return (
    <div data-testid="reread-stored-report" style={{ fontSize: 12, color: '#374151', margin: '8px 0 12px' }}>
      {!confirming && (
        <button type="button" style={btn} onClick={() => { setConfirming(true); setResult(null); setError(null); }}>
          Re-read the stored credit report
        </button>
      )}
      {confirming && (
        <div style={{ background: '#eef2ff', border: '1px solid #c7d2fe', borderRadius: 6, padding: '8px 10px' }}>
          <div style={{ marginBottom: 6 }}>
            This re-reads the credit report already on file with the current field mapping and updates the letters of
            explanation. There is no new credit pull and no inquiry. Letters already answered are kept.
          </div>
          <button type="button" style={{ ...btn, marginRight: 6 }} disabled={busy} onClick={run}>
            {busy ? 'Re-reading…' : 'Re-read the stored report'}
          </button>
          <button type="button" style={{ ...btn, color: '#6b7280', borderColor: '#e5e7eb' }} disabled={busy} onClick={() => setConfirming(false)}>
            Cancel
          </button>
        </div>
      )}
      {result && (
        <div data-testid="reread-stored-report-result" style={{ marginTop: 6 }}>
          Re-read the stored report (no new pull). Letters: {result.letters?.created ?? 0} new, {result.letters?.kept ?? 0} kept,{' '}
          {result.letters?.retired ?? 0} retired. Read {result.read?.inquiries ?? 0} inquiries and {result.read?.publicRecords ?? 0} public records.
          {result.keyCheck?.problems?.length ? ` Still not read: ${result.keyCheck.problems.join('; ')}.` : ''}
        </div>
      )}
      {error && <div style={{ marginTop: 6, color: '#991b1b' }}>{error}</div>}
    </div>
  );
}
